import { ErrorSeverity } from '../types/index.js';
/**
 * BaseError is a custom error class that extends the native JavaScript Error class.
 * It includes additional properties such as statusCode, timestamp, details, errorCode, and severity.
 *
 * @remarks
 * This class is designed to provide more context and structure to errors in an application.
 *
 * @example
 * ```typescript
 * throw new BaseError('Something went wrong', 500, { detail: 'Additional error details' }, 'ERR001');
 * ```
 *
 * @public
 *
 * @class
 * @extends {Error}
 */
export class BaseError extends Error {
    statusCode;
    timestamp;
    details;
    errorCode;
    severity;
    constructor(message, statusCode = 500, details, errorCode) {
        super(message);
        Error.captureStackTrace(this, this.constructor);
        this.statusCode = statusCode;
        this.timestamp = new Date().toISOString();
        this.details = details;
        this.errorCode = errorCode;
        this.severity = BaseError.determineSeverity(statusCode);
    }
    static determineSeverity(statusCode) {
        if (statusCode >= 500)
            return ErrorSeverity.CRITICAL;
        if (statusCode === 403 || statusCode === 401)
            return ErrorSeverity.WARNING;
        if (statusCode >= 400)
            return ErrorSeverity.INFO;
        return ErrorSeverity.INFO;
    }
    toJSON() {
        return {
            message: this.message,
            statusCode: this.statusCode,
            severity: this.severity,
            timestamp: this.timestamp,
            details: this.details,
            errorCode: this.errorCode,
        };
    }
}
//# sourceMappingURL=BaseError.js.map